module.exports = __webpack_public_path__ + "static/img/red_logo_en.a7c9ad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/red_logo_en.jpg
// module id = smCY
// module chunks = 0